import { useCookie } from "../../hooks/useCookie.hook";

export function useCartId() {
  return useCookie("cartId");
}
